import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/utils";

const RETURN_KEY = "cowrieking_first_visit";

export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lang = (typeof window !== "undefined" && localStorage.getItem("cowrieking_lang")) || "en";
    let isReturning = false;
    try {
      isReturning = !!localStorage.getItem(RETURN_KEY);
      if (!isReturning) localStorage.setItem(RETURN_KEY, String(Date.now()));
    } catch {}
    axios
      .post(`${API}/analytics/pageview`, {
        path: pathname,
        referrer: document.referrer || "",
        language: lang,
        is_returning: isReturning,
      })
      .catch(() => {});
  }, [pathname]);
  return null;
}
